import React from 'react';
import { useLocation } from 'react-router-dom';
import logo from '../../assets/jimmy.svg';
import './SideMenu.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalculator,
    faCalendarDays,
    faFileLines,
    faFolderOpen,
    faHouse,
    faScaleBalanced,
    faUser,
    faUserTie,
    faXmark,
} from '@fortawesome/free-solid-svg-icons';

const menuItems = [
    { label: 'Início', route: '/', icon: faHouse },
    { label: 'Leitor de documentos', route: '/jimmy', icon: faFileLines },
    { label: 'Calendário', route: '/calendario', icon: faCalendarDays },
    { label: 'Jurisearch', route: '/jurisprudencia', icon: faScaleBalanced },
    { label: 'Calculadora', route: '/calculadora', icon: faCalculator },
    { label: 'Modelos', route: '/modelos', icon: faFolderOpen },
    { label: 'Área do cliente', route: '/areadocliente', icon: faUserTie },
    { label: 'Perfil', route: '/perfil', icon: faUser },
];

const SideMenu = ({ handleNavigation, closeMenu, isActive }) => {
    const location = useLocation();
    const isCurrent = (route) => route === '/' ? location.pathname === '/' : location.pathname.startsWith(route);

    return (
        <div className={`side-menu-layer ${isActive ? 'open' : ''}`}>
            <button className="side-menu-backdrop" onClick={closeMenu} type="button" aria-label="Fechar menu" />
            <aside className="side-menu" aria-label="Menu principal">
                <div className="header-side-menu">
                    <img src={logo} alt="Jimmy" className="side-menu-logo" />
                    <button className="close-btn" onClick={closeMenu} type="button" aria-label="Fechar menu">
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>

                <div className="side-menu-context">
                    <span>Workspace jurídico</span>
                    <strong>Jimmy-A1 ativo</strong>
                </div>

                <nav className="container-lista-side-menu">
                    <ul className="ul-sidemenu">
                        {menuItems.map((item) => (
                            <li key={item.route}>
                                <button
                                    className={`li-sidemenu ${isCurrent(item.route) ? 'active' : ''}`}
                                    onClick={() => handleNavigation(item.route)}
                                    type="button"
                                    aria-current={isCurrent(item.route) ? 'page' : undefined}
                                >
                                    <FontAwesomeIcon icon={item.icon} />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
            </aside>
        </div>
    );
};

export default SideMenu;
